import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.REACT_APP_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.REACT_APP_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log("🔴 Supabase Config: Initializing...");
console.log("🔴 Supabase Config: URL exists:", !!supabaseUrl);
console.log("🔴 Supabase Config: Anon Key exists:", !!supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase Config: Missing environment variables!');
  console.error('❌ Supabase Config: REACT_APP_SUPABASE_URL:', supabaseUrl ? 'exists' : 'MISSING');
  console.error('❌ Supabase Config: REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'exists' : 'MISSING');
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

console.log("🔴 Supabase Config: Creating client...");
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
console.log("🔴 Supabase Config: Client created successfully");
